import { Component, OnInit, Input, ViewChild, EventEmitter, Output } from '@angular/core';
import { StorageService } from '../../_services/storage.service';
import { NgxGalleryComponent, NgxGalleryOptions } from 'ngx-gallery';
import { SrcPipe } from '../../_pipe/src.pipe';
@Component({
  selector: 'app-galleria-fotografica',
  templateUrl: './galleria-fotografica.component.html',
  styles: []
})
export class GalleriaFotograficaComponent implements OnInit {

  constructor(private storage: StorageService) { }

  galleryImages = [];
  @ViewChild('gallery', { static: true }) gallery: NgxGalleryComponent;

  @Input() urlFotoEsterno = false;

  @Output() openFotoIndexChange = new EventEmitter<number>();
  @Input() set openFotoIndex(index) {
    if (index !== null && index !== undefined) {
      this.gallery.openPreview(index);
      this.openFotoIndexChange.emit(null);
    }
  }

  @Input() foto: any[];
  galleryPlus;
  galleryOptions: NgxGalleryOptions[] = [
    {
      width: '0px',
      height: '0px',
      image: false,
      thumbnails: false,
      thumbnailsColumns: 4,
      previewSwipe: true,
      previewKeyboardNavigation: true,
      previewDescription: true,
      previewInfinityMove: true,
      previewCloseOnEsc: true,
      imageDescription: true,
      previewCloseOnClick: true,
      /*arrowNextIcon: 'icon icon-arrow-right',
      arrowPrevIcon: 'icon icon-arrow-left',
      closeIcon: 'icon icon-close'*/
    },
  ];

  ngOnInit() {
    this.galleryImages = [];
    const srcPipe = new SrcPipe();
    this.foto.forEach(foto => {
      const url = this.urlFotoEsterno ? foto.url : srcPipe.transform(foto.path, 'landscape_4_3_desktop');
      const urlMobile = this.urlFotoEsterno ? foto.url : srcPipe.transform(foto.path, 'landscape_4_3_mobile');
      this.galleryImages.push(
        {
          small: urlMobile,
          medium: urlMobile,
          big: url,
          alt: foto.alt,
          title: foto.title,
          note: foto.note,
          description: foto.alt
        });
    });
    if ((this.galleryImages.length - 4) > 0) {
      this.galleryPlus = true;
    }
  }


}
